import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMasters, normalizeMasterItems } from "../services/masterService";

const cache = {};

export function invalidateMastersCache(group) {
  if (group) {
    delete cache[group];
    return;
  }
  Object.keys(cache).forEach((key) => {
    delete cache[key];
  });
}

export function masterLabel(options, value) {
  if (!value) return "";
  return options.find((item) => item.value === value)?.label || value;
}

export function useMasters(group, fallback = []) {
  const authData = useSelector((state) => state.authReducer);
  const [options, setOptions] = useState(() => cache[group] || fallback);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      if (cache[group]?.length) {
        setOptions(cache[group]);
        return;
      }
      const res = await getMasters({ authData }, group);
      const items = normalizeMasterItems(res).filter((item) => item.active !== false);
      if (cancelled) return;
      if (items.length) {
        cache[group] = items;
        setOptions(items);
      } else {
        setOptions(fallback);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [group, authData?.accessToken]);

  return options?.length ? options : fallback;
}
